import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import Utils from 'src/app/utils';
import { TranslocoService } from '@ngneat/transloco';

declare var bootstrap: any;


@Component({
  selector: 'app-alertloop-edit',
  templateUrl: './alertloop-edit.component.html',
  styleUrls: ['./alertloop-edit.component.scss']
})
export class AlertloopEditComponent implements OnInit {

  alertloop: any;
  id?: number;
  loop_run_count: any = Utils.getLoopRunCount();
  loop_wait_times: any = Utils.getLoopWaitTimes();


  formGroup = new FormGroup({
    name: new FormControl('',[Validators.required]),
    loop_count: new FormControl('',[Validators.required]),
    loop_wait: new FormControl(0,[Validators.required]),
  });
  submitted = false;
  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  editStepForm = new FormGroup({
    user_id: new FormControl('',[Validators.required]),
    wait: new FormControl(0,[Validators.required]),
  });
  submittedEdit = false;
  get fEdit(): { [key: string]: AbstractControl } {
    return this.editStepForm.controls;
  }
  edit_step_index:any = null;


  addStepForm = new FormGroup({
    user_id: new FormControl('',[Validators.required]),
    wait: new FormControl(2,[Validators.required]),
  });
  submittedAdd = false;
  get fAdd(): { [key: string]: AbstractControl } {
    return this.addStepForm.controls;
  }



  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    this.id = +this.route.snapshot.params['id'];

    this.getAlertLoop();
    

  }

  getAlertLoop(){

    this.okService.get("alertloops/"+this.id,'')
    .subscribe((data) => {

      this.alertloop = data.body;

      this.setForm();

      
      if(!this.okService.isFromAdmin()){

        // Remove any loop times over 3 unless they are using them 
        this.loop_wait_times;
        let loop_count = this.alertloop.loop_count;

        // Filter the array based on `loop_count`
        this.loop_run_count = this.loop_run_count.filter((item: any) => 
          (item.value <= loop_count || item.value <= 3)
        );

      }

    });

  }

  setForm(){
    this.formGroup.setValue({
      name: this.alertloop.name,
      loop_count: this.alertloop.loop_count,
      loop_wait: this.alertloop.loop_wait,
    })
  }

  submitForm(){
    this.submitted = true;
    if(this.formGroup.valid){
      let values = this.formGroup.value;


      var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('editLoopModal'));
      myModal.hide();

      this.saveAlertLoop(values);



    }

  }

  setEditStepForm(step:any,index:number){

    this.edit_step_index = index;

    this.editStepForm.setValue({
      user_id: step.user_id,
      wait: +step.wait,
    });


    var myModal = new bootstrap.Modal(document.getElementById('editStepModal'));
    myModal.show();


  }

  submitEditStepForm(){


    this.submittedEdit = true;
    if(this.editStepForm.valid){

      //console.log(this.editStepForm.value);

      let step = this.editStepForm.value;


      let alertloop = JSON.parse(JSON.stringify(this.alertloop));
      alertloop.steps[this.edit_step_index] = step;

      this.saveAlertLoop(alertloop);

      var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('editStepModal'));
      myModal.hide();
    }

  }

  submitAddStepForm(){

    //console.log(this.addStepForm.value);

    this.submittedAdd = true;
    if(this.addStepForm.valid){


      let new_step = this.addStepForm.value;
      let alertloop = JSON.parse(JSON.stringify(this.alertloop));
      alertloop.steps.push(new_step);


      var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('addStepModal'));
      myModal.hide();


      this.saveAlertLoop(alertloop);

      this.addStepForm.setValue({
        user_id: '',
        wait: 2,
      })



    }

    return false;
  }

  saveAlertLoop(alertloop:any){

    //console.log(alertloop);

    this.okService.put("alertloops/"+this.id,alertloop)
    .subscribe((data) => {

      this.alertloop = data.body;

      this.okService.setAlert(this.transloco.translate("The alert loop has been updated"), "success");

    });
  }

  doDelete(){
    if(confirm(this.transloco.translate(this.transloco.translate("Are you sure you want to delete "))+this.alertloop.name)) {

      this.okService.delete("alertloops/"+this.alertloop.id)
      .subscribe((data) => {

        this.router.navigateByUrl('/mgmt/alertloops/alertloops');

      });
    }
  }

  swap(input: any, index_A: any, index_B: any) {

    if(input[index_B] && input[index_A]){

      let temp = input[index_A];
      //console.log('pre-swap',index_A,index_B);

      input[index_A] = input[index_B];
      input[index_B] = temp;

      //console.log('post-swap',index_A,index_B);
      //console.log('input step', input);

      this.saveAlertLoop(this.alertloop);
    }else{
      //console.log('Cannot swap as not two values');
    }

  }

  removeStep(i:any){
    if(this.alertloop.steps.length > 1){
      this.alertloop.steps.splice(i, 1);

      this.saveAlertLoop(this.alertloop);
    }

  }

}
